import { Component, OnInit } from '@angular/core';
import { CardContent } from 'src/app/components/card/card.component';

@Component({
  selector: 'app-simsth',
  templateUrl: './simsth.component.html',
  styleUrls: ['./simsth.component.scss']
})
export class SimsthComponent implements OnInit {

  exposition: CardContent = {
    title: 'SIM-STH',
    subtitle: 'Modelling the treatment against soil-transmitted helminths',
    image_source: 'assets/images/SIM-STH.PNG',
  };

  information: CardContent = {
    title: 'Project Info',
    sections: [
      '<h4>Partners</h4>Imperial College, LSHTM, BMGF',
      '<h4>Methods</h4>Deterministic Compartmental Modelling',
      '<h4>Technology / Skills</h4>Javascript, D3, RK4',
      '<h4>Term</h4>2014 - 2015',
      '<h4>Explore the App</h4><a href="http://sim-sth.exploratory-systems.eu">sim-sth.exploratory-systems.eu</a>'
    ]
  };

  constructor() { }

  ngOnInit(): void {
  }

}
